export interface ContractYearWindow {
  /** 1-based contract-year index: 1 = first year of marketing, etc. */
  index: number
  from: Date
  until: Date
}

const DEFAULT_CAP = 10

function addYears(date: Date, years: number): Date {
  const d = new Date(date)
  d.setFullYear(d.getFullYear() + years)
  return d
}

function addDays(date: Date, days: number): Date {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return d
}

function parseDate(value: Date | string | null | undefined): Date | null {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

export function deriveContractYearWindows(
  beginOfMarketingDate: Date | string | null | undefined,
  contractEndDate: Date | string | null | undefined,
  cap = DEFAULT_CAP
): ContractYearWindow[] {
  const start = parseDate(beginOfMarketingDate)
  const end = parseDate(contractEndDate)
  if (!start || !end || end < start) return []

  const windows: ContractYearWindow[] = []
  for (let n = 1; n <= cap; n++) {
    const from = addYears(start, n - 1)
    if (from > end) break
    const natural = addDays(addYears(start, n), -1)
    const until = natural > end ? end : natural
    windows.push({ index: n, from, until })
  }
  return windows
}

export function deriveContractYearIndices(
  beginOfMarketingDate: Date | string | null | undefined,
  contractEndDate: Date | string | null | undefined,
  cap = DEFAULT_CAP
): number[] {
  return deriveContractYearWindows(beginOfMarketingDate, contractEndDate, cap).map((w) => w.index)
}
